export default {
    timeoutModalTableCell: {},
    timeoutModalWhite: {},
    timeoutModalTable: {
        display: 'table',
        height: '100%',
        width: '100%',
        '& $timeoutModalTableCell': {
            display: 'table-cell',
            verticalAlign: 'middle',
            textAlign: 'center',
            padding: '20px'
        },
        '& $timeoutModalWhite': {
            padding: '50px 30px',
            margin: '0 auto',
            background: '#ffffff',
            top: '21%',
            textAlign: 'center',
            marginBottom: '10px',
            marginTop: '10px',
            fontFamily: data => data.fontFamily1,
            '& svg': {
                fill: data => data.mainColor,
                width: '42px',
                height: '40px',
                '@media (min-width:601px)': {
                width: '70px',
                height: '70px',
                marginBottom: '35px'
                }
            },
            '& $timeoutModalTitle': {
                fontSize: '24px',
                fontWeight: '300',
                marginBottom: '35px'
            },
            '@media (min-width:601px)': {
                padding: '45px',
                maxWidth: '470px'
            }
        },
        '& $stastarModaldinfo': {
            fontSize: '13px',
            fontWeight: '300',
            color: '#000',
            padding: '0 15px 0',
            lineHeight: '1.38'
        },
        '& $stastarModaldquest': {
            verticalAlign: 'bottom',
            height: '40px'
        }
    },
    timeoutModalTitle: {
        display: "block",
        textTransform: "uppercase",
        fontWeight: "500",
        marginBottom: "36px",
        color: "#000",
    },
    timeoutModalLogo: {
        display: 'block',
        textTransform: 'uppercase',
        fontWeight: '500',
        marginBottom: '36px',
        color: '#000'
    },
    timeoutModalInfo: {
        display: 'block',
        fontSize: '16px',
        color: '#8c8c8c',
        fontWeight: 'normal',
        lineHeight: 'normal',
        paddingBottom: '20px',
        '&:last-of-type': {
            paddingBottom: '30px'
        }
    },
    timeoutModalButton: {
        paddingTop: '20px'
    },
}

